"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConflictBody = exports.CrossesSessionBoundaryError = exports.OutOfSessionError = exports.UpdateCausesRecordingToChangeError = exports.NoRecordingAtTimeError = exports.HearingSectionConflicts = exports.HearingSectionConflict = exports.HearingSection = exports.HearingSectionSchema = exports.UpdateCaseRequest = exports.Case = exports.CaseTitleSchema = exports.MIN_CASE_TITLE_LENGTH = exports.MAX_CASE_TITLE_LENGTH = exports.CaseReferenceSchema = exports.MIN_CASE_REFERENCE_LENGTH = exports.MAX_CASE_REFERENCE_LENGTH = void 0;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
const refine_1 = require("../util/refine");
const joda_schemas_1 = require("./joda.schemas");
exports.MAX_CASE_REFERENCE_LENGTH = 1000;
exports.MIN_CASE_REFERENCE_LENGTH = 1;
exports.CaseReferenceSchema = zod_1.default
    .string()
    .trim()
    .min(exports.MIN_CASE_REFERENCE_LENGTH)
    .max(exports.MAX_CASE_REFERENCE_LENGTH)
    .transform(value => value.toUpperCase());
exports.MAX_CASE_TITLE_LENGTH = 1000;
exports.MIN_CASE_TITLE_LENGTH = 1;
exports.CaseTitleSchema = zod_1.default
    .string()
    .trim()
    .min(exports.MIN_CASE_TITLE_LENGTH)
    .max(exports.MAX_CASE_TITLE_LENGTH)
    .transform(value => value.replaceAll('\n', ' '));
const CaseSchema = zod_1.default.object({
    id: zod_1.default.string().uuid(),
    courtSystemId: zod_1.default.string().uuid(),
    caseReference: exports.CaseReferenceSchema,
    title: exports.CaseTitleSchema.nullable(),
    hearingCount: zod_1.default.number(),
    lastHeardDate: joda_schemas_1.LocalDateSchema.nullable(),
});
exports.Case = CaseSchema.refine((refine_1.is));
const UpdateCaseRequestSchema = CaseSchema.pick({ caseReference: true, title: true });
exports.UpdateCaseRequest = UpdateCaseRequestSchema.refine((refine_1.is));
exports.HearingSectionSchema = zod_1.default.object({
    id: zod_1.default.string().uuid(),
    recordingId: zod_1.default.string().uuid(),
    locationId: zod_1.default.string().uuid(),
    courtSystemId: zod_1.default.string().uuid(),
    recordingDate: joda_schemas_1.LocalDateSchema,
    startTime: joda_schemas_1.LocalTimeNoNanosSchema,
    endTime: joda_schemas_1.LocalTimeNoNanosSchema,
    title: exports.CaseTitleSchema.nullable(),
    caseReference: exports.CaseReferenceSchema.nullable(),
    hearingId: zod_1.default.string().uuid().nullable(),
});
exports.HearingSection = exports.HearingSectionSchema.refine((refine_1.is));
const HearingSectionConflictSchema = zod_1.default.object({
    hearingSectionId: zod_1.default.string().uuid(),
    hearingId: zod_1.default.string().uuid().nullable(),
    type: zod_1.default.enum(['start-overlap', 'end-overlap', 'complete-overlap']),
});
exports.HearingSectionConflict = HearingSectionConflictSchema.refine((refine_1.is));
const HearingSectionConflictsSchema = zod_1.default.object({
    type: zod_1.default.literal('HearingSectionConflicts'),
    error: zod_1.default.string(),
    conflicts: zod_1.default.array(HearingSectionConflictSchema),
    conflictResolutionToken: zod_1.default.string(),
});
exports.HearingSectionConflicts = HearingSectionConflictsSchema.refine((refine_1.is));
const NoRecordingAtTimeErrorSchema = zod_1.default.object({
    type: zod_1.default.literal('NoRecordingAtTimeError'),
    error: zod_1.default.literal('No recording found for the given location and time'),
});
exports.NoRecordingAtTimeError = NoRecordingAtTimeErrorSchema.refine((refine_1.is));
const UpdateCausesRecordingToChangeErrorSchema = zod_1.default.object({
    type: zod_1.default.literal('UpdateCausesRecordingToChangeError'),
    error: zod_1.default.literal('This update would cause the recording to change. To change the date or location, delete and recreate the hearing section'),
});
exports.UpdateCausesRecordingToChangeError = UpdateCausesRecordingToChangeErrorSchema.refine((refine_1.is));
const OutOfSessionErrorSchema = zod_1.default.object({
    type: zod_1.default.literal('OutOfSessionError'),
    error: zod_1.default.literal('The requested time is outside of the session'),
});
exports.OutOfSessionError = OutOfSessionErrorSchema.refine((refine_1.is));
const CrossesSessionBoundaryErrorSchema = zod_1.default.object({
    type: zod_1.default.literal('CrossesSessionBoundaryError'),
    error: zod_1.default.literal('The hearing section crosses a session boundary'),
});
exports.CrossesSessionBoundaryError = CrossesSessionBoundaryErrorSchema.refine((refine_1.is));
exports.ConflictBody = exports.HearingSectionConflicts.or(exports.NoRecordingAtTimeError)
    .or(exports.OutOfSessionError)
    .or(exports.CrossesSessionBoundaryError);
